import { Agency } from "entities/UIModel";
// import { DocumentType } from "utils/data/enum";
import { ImageArchiveUI } from "entities/UIModel/ImageArchiveUI";
import { Message } from "entities/UIModel";
import { StoreActionApi } from "react-sweet-state";

import { axiosSecuredInstance } from "configurations/axiosConfig";
import { createHook } from "react-sweet-state";
import { createStore } from "react-sweet-state";
import { mapToUiMessages } from "utils/data/messageGridhelper";
interface State {
  isLoading: boolean;
  error: string | null;
  uploadImageLastSelectedAgency: Agency | null;
  isTitleSearchGridInEditMode: boolean;
  isTitleSearchGridInShowToastMode: boolean;  
  selectedTitleSearchGridItems: ImageArchiveUI[];
  hasSentMessageSuccessfully: boolean;

}

type StoreApi = StoreActionApi<State>;

const Store = createStore<State, any>({
  initialState: {
    isLoading: false,
    error: null,
    uploadImageLastSelectedAgency: null,
    isTitleSearchGridInEditMode: false,
    isTitleSearchGridInShowToastMode: false,
    selectedTitleSearchGridItems: [],
    hasSentMessageSuccessfully: false,
  },
  actions: {
    getMessageByOrder:
    // (searchCriteria: Message ) =>
    // async ({ dispatch, setState }: StoreApi) => {
    //   try {
    //     setState({ isLoading: true });

    //     const { data } = await axiosSecuredInstance.get(
    //       `/Order/GetMessageListByOrder?orderId=${
    //         searchCriteria?.orderID
    //       }&showHidden=${searchCriteria?.isHidden || 0}`
    //     );

    //     const mappedData = dispatch(mapToUiMessages(data));
    //     return mappedData;
    //   } catch (error: any) {
    //     console.log(error);
    //   }
    // },
    (searchCriteria: Message) =>
    async ({ dispatch, setState }: StoreApi) => {
      try {
        setState({ isLoading: true });

        const { data } = await axiosSecuredInstance.get(
          `/Order/GetMessageListByOrder?orderId=${
            searchCriteria?.orderId || 0
          }&showHidden=${searchCriteria?.showHidden || 1}&orderBy=${
            searchCriteria?.sortColumn || ""
          }`
        );
        const mappedData = dispatch(mapToUiMessages(data));
        setState({ isLoading: false });
        return mappedData; // dispatch(setFilesRecordList(data));
      } catch (error: any) {
        console.log(error);
        setState({ isLoading: false });
      }
    },
    toggleMessageHidden:
    (messageID: number, isHidden: boolean ,fileID :number) =>
    async () => {
      try {
        await axiosSecuredInstance.post("/Order/SaveMessage", {
          messageID,
          isHidden,
          fileID,
        });
      } catch (error) {
        console.error("Error toggling message visibility:", error);
      }
    },
    // uploadFiles:
    //   (requestId: string, formData: FormData, documentTypeCode: string = DocumentType.TITLEDOCS) =>
    //   async ({ dispatch, setState }: StoreApi) => {
    //     try {
    //       // dispatch(setLoading());
    //       setState({ isLoading: true });
    //       const { data } = await axiosSecuredInstance.post(
    //         `/documents/fileupload?requestId=${requestId}&documentTypeCode=${documentTypeCode}`,
    //         formData,
    //         { headers: { "Content-Type": "multipart/form-data" } },
    //       );
    //       setState({ isLoading: false });
    //       return data;
    //     } catch (error) {
    //       // dispatch(setError(String(error)));
    //       setState({ isLoading: false });
    //     }
    //   },
      sendMessageDoc:
      (message: Message, documentOnly: boolean) =>
      async ({ setState }: StoreActionApi<State>) => {
        try {
          setState({ isLoading: true, hasSentMessageSuccessfully: false });
              const response = await axiosSecuredInstance.post(
            `/Order/SendMessageDoc?documentOnly=${documentOnly}`,
            message
          );
    
          setState({
            isLoading: false,
            hasSentMessageSuccessfully: true,
          });
    
          return response.data;
        } catch (error: any) {
          setState({
            isLoading: false,
            error: error.message,
            hasSentMessageSuccessfully: true,
          });
          console.error("Failed to send message document:", error);
          throw error;
        }
      },
      sendUnderWriterMessageDoc:
      (message: Message, documentOnly: boolean) =>
      async ({ setState }: StoreActionApi<State>) => {
        try {
          setState({ isLoading: true, hasSentMessageSuccessfully: false });
              const response = await axiosSecuredInstance.post(
            `Underwriter/SaveMessageDoc?documentOnly=${documentOnly}`,
            message
          );
    
          setState({
            isLoading: false,
            hasSentMessageSuccessfully: true,
          });
    
          return response.data;
        } catch (error: any) {
          setState({
            isLoading: false,
            error: error.message,
            hasSentMessageSuccessfully: true,
          });
          console.error("Failed to send message document:", error);
          throw error;
        }
      },    
    deleteDocuments:
      (documentIds: number[]) =>
      async ({ setState }: StoreApi) => {
        try {
          setState({ isLoading: true });
          await axiosSecuredInstance.post("/Documents/DeleteDocuments", documentIds);
          setState({ isLoading: false });
        } catch (error: any) {
          console.error("Failed to delete documents:", error);
          setState({ isLoading: false, error: error.message });
          throw error;
        }
      },
      deleteUWADocuments:
      (documentIds: number[]) =>
      async ({ setState }: StoreApi) => {
        try {
          setState({ isLoading: true });
          await axiosSecuredInstance.post("/Underwriter/DeleteUWADocuments", documentIds);
          setState({ isLoading: false });
        } catch (error: any) {
          console.error("Failed to delete documents:", error);
          setState({ isLoading: false, error: error.message });
          throw error;
        }
      },

  },
  
  name: "message",
});

const hook = createHook(Store);
export const useHasSentMessageSuccessfully = createHook(Store, {
  selector: (state) => ({
    hasSentMessageSuccessfully: state.hasSentMessageSuccessfully,
    isLoading: state.isLoading,
  }),
});


export const useMessage = () => { return hook(); };
